import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Footer.css';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLightMode, setIsLightMode] = useState(() => {
    return document.body.classList.contains('light-mode') || 
           document.querySelector('.landing-page')?.classList.contains('light-mode');
  });

  // Listen for theme changes
  useEffect(() => {
    const checkLightMode = () => {
      setIsLightMode(
        document.body.classList.contains('light-mode') || 
        document.querySelector('.landing-page')?.classList.contains('light-mode')
      );
    };
    
    // Check immediately
    checkLightMode();
    
    // Set up observer to watch for class changes
    const observer = new MutationObserver(checkLightMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    
    const landingPage = document.querySelector('.landing-page');
    if (landingPage) {
      observer.observe(landingPage, { attributes: true, attributeFilter: ['class'] });
    }
    
    return () => observer.disconnect();
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const Modal = () => (
    <div className="footer-modal-overlay" onClick={closeModal}>
      <div className="footer-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="footer-modal-header">
          <h3>Investment Disclaimer</h3>
          <button className="footer-modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="footer-modal-body">
          <p>This document is an informational document that primarily provides educational content and general market commentary. Except for certain sections specifically marked in this document, no statements included herein relate specifically to investment advisory services provided by Pantera Capital Management Puerto Rico LP or its affiliates ("Pantera"), nor does any content herein reflect or contain any offer of new or additional investment advisory services. Nothing contained herein constitutes an investment recommendation, investment advice, an offer to sell, or a solicitation to purchase any securities in Funds managed by Pantera (the "Funds") or any entity organized, controlled, or managed by Pantera and therefore may not be relied upon in connection with any offer or sale of securities. Any offer or solicitation may only be made pursuant to a confidential private offering memorandum (or similar document) which will only be provided to qualified offerees and should be carefully reviewed by any such offerees prior to investing.</p>

          <p>This document aims to summarize certain developments, articles, and/or media mentions with respect to Bitcoin and other cryptocurrencies that Pantera believes may be of interest. The views expressed in this document are the subjective views of Pantera personnel, based on information that is believed to be reliable and has been obtained from sources believed to be reliable, but no representation or warranty is made, expressed, or implied, with respect to the fairness, correctness, accuracy, reasonableness, or completeness of the information and opinions. The information contained in this document is current as of the date indicated at the front of the document. Pantera does not undertake to update the information contained herein.</p>

          <p>This document is not intended to provide, and should not be relied on for accounting, legal, or tax advice, or investment recommendations. Pantera and its principals have made investments in some of the instruments discussed in this communication and may in the future make additional investments, including taking both long and short positions, in connection with such instruments without further notice.</p>

          <p>Certain information contained in this document constitutes "forward-looking statements", which can be identified by the use of forward-looking terminology such as "may", "will", "should", "expect", "anticipate", "target", "project", "estimate", "intend", "continue", "believe", or the negatives thereof or other variations thereon or comparable terminology. Due to various risks and uncertainties, actual events or results or the actual policies, procedures, and processes of Pantera and the performance of the Fund may differ materially from those reflected or contemplated in such forward-looking statements, and no undue reliance should be placed on these forward-looking statements, nor should the inclusion of these statements be regarded as Pantera's representation that the Fund will achieve any strategy, objectives, or other plans. Past performance is not necessarily indicative of or a guarantee of future results.</p>

          <p>It is strongly suggested that any prospective investor obtain independent advice in relation to any investment, financial, legal, tax, accounting, or regulatory issues discussed herein. Analyses and opinions contained herein may be based on assumptions that if altered can change the analyses or opinions expressed. Nothing contained herein shall constitute any representation or warranty as to future performance of any financial instrument, credit, currency rate, or other market or economic measure.</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-item">
              <a 
                href="https://sui414.notion.site/Methodology-2a36da126dcb809bb75ff12bff88822a" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-methodology-link"
              >
                <h4>Methodology</h4>
              </a>
            </div>
            <div className="footer-item">
              <h4 className="footer-link" onClick={openModal}>Investment Disclaimer</h4>
            </div>
          </div>
          
          <div className="footer-center">
            <a 
              href="https://panteraresearchlab.xyz/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-logo-link"
            >
              <img 
                src={isLightMode ? '/images/light_mode_icon.png' : '/images/dark_mode_icon.png'}
                alt="Pantera Research Lab" 
                className="footer-logo"
              />
              <span className="footer-logo-text">Pantera Research Lab</span>
            </a>
          </div>
          
          <div className="footer-right">
            <div className="footer-item">
              <a 
                href="https://x.com/sui414" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-twitter-link"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                sui414
              </a>
            </div>
            <div className="footer-item">
              <a 
                href="https://x.com/0xallyzach" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-twitter-link"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                0xallyzach
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Pantera Research Lab. All rights reserved.</p>
          <p className="footer-disclaimer">
            Pantera Capital and its affiliates are investors in several of the Digital Asset Treasury (DAT) companies, including certain companies included in the digital asset treasury board. Additionally, Pantera Capital serves as a strategic advisor to Solana Company (Nasdaq: HSDT). The information provided are exclusively views and opinions of Pantera Capital and do not necessarily reflect the views, positions or statements of any of the DAT companies referenced. The information provided has been prepared independently and does not represent or purport to represent any official position, statement or communication made by any person or company other than Pantera Capital. The analysis presented here is intended solely for informational and research purposes and does not constitute financial, investment, or trading advice. Readers should conduct their own due diligence and consult professional advisors before making any investment decisions. The information provided herein is based on current information and assumptions and does not include information on every DAT in existence. Pantera Capital undertakes no obligation to update or revise any statements to reflect subsequent events or circumstances.
          </p>
        </div>
      </footer>

      {/* Modal rendered via portal */}
      {isModalOpen && createPortal(<Modal />, document.body)}
    </>
  );
};

export default Footer;
